import { useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";

const categories = [
  { key: "todos", label: "Todos" },
  { key: "praias", label: "Praias" },
  { key: "cidades", label: "Cidades" },
  { key: "aventura", label: "Aventura" },
  { key: "luxo", label: "Luxo" },
];

const destinations = [
  { id: 1, name: "Maldivas", country: "República das Maldivas", category: ["praias","luxo"], price: "A partir de R$ 8.500", desc: "Ilhas paradisíacas com águas cristalinas, bangalôs sobre o mar e pôr do sol deslumbrante.", image: "https://images.unsplash.com/photo-1620483829646-8fb1d8162108?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxtYWxkaXZlcyUyMHdhdGVyJTIwdmlsbGElMjBhZXJpYWx8ZW58MHx8fHwxNzc0NDQzODc2fDA&ixlib=rb-4.1.0&q=85" },
  { id: 2, name: "Paris", country: "França", category: ["cidades","luxo"], price: "A partir de R$ 5.900", desc: "A cidade luz, com sua arte, gastronomia, moda e arquitetura incomparável.", image: "https://images.pexels.com/photos/587838/pexels-photo-587838.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { id: 3, name: "Alpes Suíços", country: "Suíça", category: ["aventura","luxo"], price: "A partir de R$ 7.800", desc: "Montanhas imponentes, esqui de primeira, aldeias charmosas e natureza exuberante.", image: "https://images.pexels.com/photos/4159997/pexels-photo-4159997.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { id: 4, name: "Rio de Janeiro", country: "Brasil", category: ["praias","aventura"], price: "A partir de R$ 1.200", desc: "A cidade maravilhosa: Cristo Redentor, Copacabana, samba e cultura vibrante.", image: "https://images.pexels.com/photos/6580703/pexels-photo-6580703.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { id: 5, name: "Cancún", country: "México", category: ["praias"], price: "A partir de R$ 4.200", desc: "Praias de areia branca, mar turquesa, ruínas maias e vida noturna animada.", image: "https://images.pexels.com/photos/506810/pexels-photo-506810.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { id: 6, name: "Nova York", country: "Estados Unidos", category: ["cidades"], price: "A partir de R$ 6.500", desc: "A cidade que nunca dorme: Times Square, Broadway, Central Park e diversidade única.", image: "https://images.pexels.com/photos/802024/pexels-photo-802024.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { id: 7, name: "Santorini", country: "Grécia", category: ["praias","luxo"], price: "A partir de R$ 9.200", desc: "Casas brancas com cúpulas azuis, vulcões, vinho local e pôr do sol lendário.", image: "https://images.pexels.com/photos/1285625/pexels-photo-1285625.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { id: 8, name: "Machu Picchu", country: "Peru", category: ["aventura"], price: "A partir de R$ 3.800", desc: "A cidade inca perdida nas montanhas, patrimônio da humanidade e maravilha do mundo.", image: "https://images.pexels.com/photos/975771/pexels-photo-975771.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { id: 9, name: "Dubai", country: "Emirados Árabes", category: ["luxo","cidades"], price: "A partir de R$ 8.000", desc: "Arranha-céus futuristas, shopping de luxo, deserto e experiências únicas no mundo.", image: "https://images.pexels.com/photos/1519088/pexels-photo-1519088.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
];

const Destinations = () => {
  const [activeCategory, setActiveCategory] = useState("todos");
  const filtered = activeCategory === "todos" ? destinations : destinations.filter((d) => d.category.includes(activeCategory));

  return (
    <div data-testid="destinations-page" className="pt-16 md:pt-20">
      <section className="page-hero flex items-center justify-center min-h-[350px] relative overflow-hidden">
        <div className="absolute inset-0 bg-cover bg-center opacity-40"
          style={{ backgroundImage: "url(https://images.pexels.com/photos/2724079/pexels-photo-2724079.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600)" }} />
        <div className="relative z-10 text-center text-white px-4">
          <p className="text-[#89A6A3] font-semibold tracking-widest text-sm uppercase mb-3">Explore o mundo</p>
          <h1 className="font-heading text-4xl md:text-6xl font-bold">Destinos</h1>
          <p className="mt-4 text-white/80 text-lg max-w-xl mx-auto">De praias paradisíacas a metrópoles vibrantes — temos o destino perfeito para você.</p>
        </div>
      </section>

      <section data-testid="category-filter-section" className="py-8 bg-white border-b border-slate-100 sticky top-16 md:top-20 z-30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex gap-3 overflow-x-auto pb-1">
            {categories.map((cat) => (
              <button key={cat.key} data-testid={`filter-btn-${cat.key}`} onClick={() => setActiveCategory(cat.key)}
                className={`flex-shrink-0 px-5 py-2 rounded-full text-sm font-semibold transition-all duration-200 ${
                  activeCategory === cat.key ? "bg-[#89A6A3] text-[#2E4E72] shadow-md" : "bg-slate-100 text-slate-600 hover:bg-slate-200"
                }`}>
                {cat.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      <section data-testid="destinations-grid-section" className="py-16 bg-[#F4F7F6]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-slate-500 text-sm mb-8">{filtered.length} destino{filtered.length !== 1 ? 's' : ''} encontrado{filtered.length !== 1 ? 's' : ''}</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {filtered.map((dest) => (
              <div key={dest.id} data-testid={`destination-card-${dest.name.toLowerCase().replace(/\s+/g, '-')}`}
                className="bg-white rounded-2xl overflow-hidden shadow-sm card-hover border border-slate-100 group">
                <div className="overflow-hidden h-52">
                  <img src={dest.image} alt={dest.name} className="dest-img w-full h-full object-cover" loading="lazy" />
                </div>
                <div className="p-6">
                  <div className="flex gap-2 mb-3">
                    {dest.category.map((c) => (
                      <span key={c} className="text-xs bg-[#B0CAC5] text-[#2E4E72] font-semibold px-2.5 py-1 rounded-full capitalize">{c}</span>
                    ))}
                  </div>
                  <h3 className="font-heading text-xl font-bold text-[#2E4E72]">{dest.name}</h3>
                  <p className="text-slate-500 text-sm flex items-center gap-1 mb-3"><MapPin size={12} /> {dest.country}</p>
                  <p className="text-slate-600 text-sm leading-relaxed mb-4">{dest.desc}</p>
                  <div className="flex items-center justify-between">
                    {/* <span className="text-[#89A6A3] font-bold text-sm">{dest.price}</span> */}
                    <Link to="/contato" data-testid={`dest-cta-${dest.name.toLowerCase().replace(/\s+/g, '-')}`}
                      className="text-[#2E4E72] font-semibold text-sm inline-flex items-center gap-1 hover:text-[#89A6A3] hover:gap-2 transition-all duration-200">
                      Solicitar <ArrowRight size={14} />
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#2E4E72] py-16 text-center">
        <div className="max-w-3xl mx-auto px-4">
          <h2 className="font-heading text-3xl font-bold text-white mb-4">Não viu seu destino dos sonhos?</h2>
          <p className="text-white/75 mb-8">Trabalhamos com destinos em todos os continentes. Entre em contato e planejamos juntos!</p>
          <Link to="/contato" data-testid="destinations-cta-btn"
            className="bg-[#89A6A3] text-[#2E4E72] font-bold px-10 py-4 rounded-full text-lg hover:bg-[#6B8C89] hover:text-white hover:scale-105 transition-all duration-300 inline-block">
            Solicitar Destino Personalizado
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Destinations;
